(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart-backup"]) return;
  try {
    
(function () {
  const mountSelector = '#mini-cart-complementary';
  function q(sel, root=document){ return root.querySelector(sel); }

  async function loadMiniCartComplementary(productId) {
    const mount = q(mountSelector);
    if (!mount) return;
    if (!productId) { mount.innerHTML = ''; return; }

    try {
      const sectionId = 'mini-cart-complementary';
      const url = `/recommendations/products?section_id=${sectionId}&product_id=${productId}&intent=complementary&limit=10`;
      const res = await fetch(url, { headers: { 'Accept': 'text/html' } });
      const html = await res.text();
      // Log for debugging:
      console.debug('[mini-cart-complementary] fetch', url, 'len=', html.length);
      mount.innerHTML = html.trim() ? html : '';
    } catch (e) {
      console.warn('[mini-cart-complementary] failed:', e);
    }
  }

  async function getLastProductIdFromCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await res.json();
    if (!cart.items || cart.items.length === 0) return null;
    // Focal: newest item is at the END
    return cart.items[cart.items.length - 1].product_id;
  }

  async function refreshFromCart() {
    const pid = await getLastProductIdFromCart();
    await loadMiniCartComplementary(pid);
  }

  // ---- Focal 12.x hooks ----
  // 1) After AJAX add-to-cart
  document.addEventListener('variant:add', async (e) => {
    // Prefer event payload; fallback to cart fetch
    const items = e.detail && e.detail.items;
    const cart  = e.detail && e.detail.cart;
    const lastPayload = items && items[items.length - 1];
    const pid = lastPayload?.product_id || (cart?.items?.[cart.items.length - 1]?.product_id) || await getLastProductIdFromCart();
    console.debug('[mini-cart-complementary] variant:add pid=', pid);
    await loadMiniCartComplementary(pid);
  });

  // 2) Any cart change (qty, remove, etc.)
  document.addEventListener('cart:change', () => {
    console.debug('[mini-cart-complementary] cart:change');
    refreshFromCart();
  });

  // 3) Drawer opened (Maestrooo dialog system)
  document.addEventListener('dialog:after-show', (e) => {
    const el = e.target;
    // Guard: only when the cart drawer opens
    const looksLikeCart = el && (el.id?.includes('cart') || el.getAttribute('aria-label') === 'Cart');
    if (looksLikeCart) {
      console.debug('[mini-cart-complementary] dialog:after-show (cart)');
      refreshFromCart();
    }
  });

  // 4) Safety refresh when theme forces cart UI updates
  document.documentElement.addEventListener('cart:refresh', () => {
    console.debug('[mini-cart-complementary] cart:refresh');
    refreshFromCart();
  });

  // 5) First paint in case the drawer is already in DOM
  if (q(mountSelector)) {
    setTimeout(refreshFromCart, 0);
  }

  // 6) If your header injects/re-renders the drawer later, observe DOM and hydrate once mount appears
  const obs = new MutationObserver(() => {
    const mount = q(mountSelector);
    if (mount && !mount.dataset._hydrated) {
      mount.dataset._hydrated = '1';
      console.debug('[mini-cart-complementary] mount detected via MutationObserver');
      refreshFromCart();
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  (function () {
    const mountSelector = '#mini-cart-complementary-mount';
    const miniCartSectionHandle = 'mini-cart';
    let isLoading = false;
    let isSubscriptionBusy = false;

    function q(sel, root = document) {
      return root.querySelector(sel);
    }

    async function renderMiniCartSection() {
      const response = await fetch('/?section_id=mini-cart', {
        headers: { Accept: 'text/html' }
      });

      if (!response.ok) {
        throw new Error(`Mini-cart section reload failed: ${response.status}`);
      }

      const html = await response.text();
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;

      const newMiniCart = wrapper.querySelector('#mini-cart');
      const currentMiniCart = document.querySelector('#mini-cart');

      if (!newMiniCart || !currentMiniCart) {
        throw new Error('Mini-cart markup not found during section refresh');
      }

      currentMiniCart.innerHTML = newMiniCart.innerHTML;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    async function updateLineSellingPlan(line, quantity, sellingPlanId) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity),
          selling_plan: sellingPlanId ? Number(sellingPlanId) : null
        })
      });

      if (!response.ok) {
        let message = `Cart update failed: ${response.status}`;

        try {
          const errorData = await response.json();
          if (errorData && errorData.description) {
            message = errorData.description;
          }
        } catch (e) {}

        throw new Error(message);
      }

      await response.json();
    }

    async function handleSubscribeToggle(toggle) {
      if (!toggle || isSubscriptionBusy) return;

      const wrapper = toggle.closest('.mini-cart-subscribe');
      const selectWrap = wrapper ? wrapper.querySelector('.mini-cart-subscribe__select-wrap') : null;
      const select = wrapper ? wrapper.querySelector('.js-mini-cart-subscribe-plan') : null;

      if (!wrapper || !selectWrap || !select) return;

      if (toggle.checked) {
        selectWrap.classList.remove('hidden');
        wrapper.classList.add('is-active');

        if (!select.value) {
          select.focus();
        }
        return;
      }

      try {
        isSubscriptionBusy = true;
        wrapper.classList.add('is-loading');

        await updateLineSellingPlan(toggle.dataset.line, toggle.dataset.quantity, null);
        await renderMiniCartSection();
      } catch (error) {
        console.error('Failed removing subscription:', error);
        alert(error.message || 'Unable to remove subscription.');
      } finally {
        isSubscriptionBusy = false;
        wrapper.classList.remove('is-loading');
      }
    }

    async function handleSubscribePlanChange(select) {
      if (!select || isSubscriptionBusy) return;
      if (!select.value) return;

      const wrapper = select.closest('.mini-cart-subscribe');
      const toggle = wrapper ? wrapper.querySelector('.js-mini-cart-subscribe-toggle') : null;

      if (!wrapper || !toggle) return;

      try {
        isSubscriptionBusy = true;
        wrapper.classList.add('is-loading');
        toggle.checked = true;

        await updateLineSellingPlan(select.dataset.line, select.dataset.quantity, select.value);
        await renderMiniCartSection();
      } catch (error) {
        console.error('Failed updating subscription plan:', error);
        alert(error.message || 'Unable to update subscription frequency.');
      } finally {
        isSubscriptionBusy = false;
        wrapper.classList.remove('is-loading');
      }
    }

    async function loadComplementaryProducts(productIds) {
      if (isLoading) return;
      isLoading = true;

      const mount = q(mountSelector);
      if (!mount) {
        isLoading = false;
        return;
      }

      if (!productIds || productIds.length === 0) {
        mount.innerHTML = '';
        isLoading = false;
        return;
      }

      try {
        const allRecommendations = [];
        const seenProductHandles = new Set();
        let totalRecommendationsFound = 0;

        for (const productId of productIds) {
          try {
            const url = `/recommendations/products?section_id=mini-cart-complementary&product_id=${productId}&intent=complementary&limit=20`;

            const res = await fetch(url, {
              headers: { Accept: 'text/html' },
              signal: AbortSignal.timeout(5000),
            });

            if (res.ok) {
              const html = await res.text();
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = html;

              const productItems = tempDiv.querySelectorAll('product-item');
              const productRecommendationCount = productItems.length;
              totalRecommendationsFound += productRecommendationCount;

              if (productRecommendationCount === 0) {
                continue;
              }

              productItems.forEach((item) => {
                const productLink = item.querySelector('a[href*="/products/"]');
                if (productLink) {
                  const href = productLink.getAttribute('href');
                  const urlParts = href.split('/products/')[1];
                  const productHandle = urlParts ? urlParts.split('?')[0].split('/')[0].split('#')[0] : null;

                  if (productHandle && productHandle.length > 0 && !seenProductHandles.has(productHandle)) {
                    seenProductHandles.add(productHandle);
                    allRecommendations.push(item.outerHTML);
                  }
                }
              });
            } else {
              console.warn(
                `Failed to fetch recommendations for product ${productId}: HTTP ${res.status} - continuing with other products`
              );
            }
          } catch (e) {
            console.warn(
              `Failed to fetch recommendations for product ${productId}:`,
              e,
              '- continuing with other products'
            );
          }
        }

        if (allRecommendations.length > 0) {
          const combinedHTML = `
            <div class="mini-cart__recommendations-inner">
              <p class="mini-cart__recommendations-heading heading heading--small hidden-pocket">You may also like</p>
              <p class="mini-cart__recommendations-heading heading heading--xsmall text--subdued hidden-lap-and-up">You may also like</p>
              <div class="mini-cart__recommendations-list">
                ${allRecommendations.join('')}
              </div>
            </div>
          `;
          mount.innerHTML = combinedHTML;
        } else {
          mount.innerHTML = '';
        }
      } catch (e) {
        console.warn('Failed to load complementary products:', e);
        mount.innerHTML = '';
      } finally {
        isLoading = false;
      }
    }

    async function getAllProductIdsFromCart() {
      try {
        const res = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          signal: AbortSignal.timeout(3000),
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const cart = await res.json();
        if (!cart.items || cart.items.length === 0) return [];

        return [...new Set(cart.items.map((item) => item.product_id))];
      } catch (e) {
        console.warn('Failed to get cart items:', e);
        return [];
      }
    }

    async function refreshFromCart() {
      const pids = await getAllProductIdsFromCart();
      await loadComplementaryProducts(pids);
    }

    document.addEventListener('change', (event) => {
      const toggle = event.target.closest('.js-mini-cart-subscribe-toggle');
      if (toggle) {
        handleSubscribeToggle(toggle);
        return;
      }

      const select = event.target.closest('.js-mini-cart-subscribe-plan');
      if (select) {
        handleSubscribePlanChange(select);
      }
    });

    document.addEventListener('variant:add', refreshFromCart);
    document.addEventListener('cart:change', refreshFromCart);
    document.addEventListener('cart:refresh', refreshFromCart);

    document.addEventListener('dialog:after-show', (e) => {
      const el = e.target;
      if (el && (el.id?.includes('cart') || el.getAttribute('aria-label') === 'Cart')) {
        refreshFromCart();
      }
    });

    if (q(mountSelector)) {
      setTimeout(refreshFromCart, 100);
    }

    const obs = new MutationObserver(() => {
      const mount = q(mountSelector);
      if (mount && !mount.dataset._hydrated) {
        mount.dataset._hydrated = '1';
        refreshFromCart();
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
